import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy, Router } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideTranslateHttpLoader, TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideTranslateService, TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { IQConnectDeviceModule } from './components/iq-connect-device/iq-connect-device.module';
import { ProtocolPopoverComponent } from './components/protocol-popover/protocol-popover.component';
import { IQConnectEmulatorModule } from './components/iq-connect-emulator/iq-connect-emulator.module';
import { environment } from 'src/environments/environment';
import { AuthenticationApiConfiguration } from './api/proxy/authentication/authentication-api-configuration';
import { EnvironmentApiConfiguration } from './api/proxy/environment/environment-api-configuration';
import { PracticeApiConfiguration } from './api/proxy/practice/practice-api-configuration';
import { GlobalHttpInterceptorService } from './services/auth-service/global-http-intercepter-service';
import { MainMenuModule } from './components/main-menu/main-menu.module';
import { LoaderModule } from './components/loader/loader.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgxIntlTelInputModule } from '@justin-s/ngx-intl-tel-input';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { bleClientFactory, BLEManagerService } from './services/ble/ble-manager.service';
import { EnvironmentConfigService } from './services/environment-config-service/environment-config-service';
import { BLE_CLIENT } from './services/ble/ble-client.token';
import * as Sentry from '@sentry/angular';
// export function createTranslateLoader(http: HttpClient) {
//   return new TranslateHttpLoader(http, './assets/i18n/', '.json');
// }

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule,
    IonicModule.forRoot({ innerHTMLTemplatesEnabled: true }),
    TranslatePipe,
    TranslateDirective,
    AppRoutingModule,
    LoaderModule,
    NgApexchartsModule,
    NgxIntlTelInputModule,
    BrowserAnimationsModule,
    MainMenuModule,
    IQConnectDeviceModule,
    ProtocolPopoverComponent,
    IQConnectEmulatorModule,
    IQConnectDeviceModule,
    DragDropModule,
  ],
  providers: [
    provideTranslateService(),
    { provide: EnvironmentApiConfiguration, useValue: { rootUrl: environment.appEnvironmentBaseUrl } },
    { provide: PracticeApiConfiguration, useValue: { rootUrl: '' } },
    { provide: AuthenticationApiConfiguration, useValue: { rootUrl: '' } },
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler() },
    { provide: Sentry.TraceService, deps: [Router] },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: GlobalHttpInterceptorService, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: (env: EnvironmentConfigService) => {
        return () => {
          if (env.initialized === false) {
            return env.init();
          }
          return Promise.resolve();
        };
      },
      deps: [EnvironmentConfigService],
      multi: true
    },
    {
      provide: BLE_CLIENT,
      useFactory: bleClientFactory,
    },
    BLEManagerService,
    provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: '.json',
      enforceLoading: false,
      useHttpBackend: false
    }),
    provideHttpClient(withInterceptorsFromDi())
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(_trace: Sentry.TraceService) { }
}